"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialDataMiddleware = void 0;
var _react = require("react");
/* eslint-disable @typescript-eslint/strict-boolean-expressions -- okay in this case as value can be generic */

const initialDataMiddleware = useSWRNext => (key, fetcher, config) => {
  const hasMounted = (0, _react.useRef)(false);
  const fallbackConfig = {
    ...config,
    fallbackData: hasMounted.current ? undefined : config.fallbackData,
    revalidateOnMount: config.revalidateOnMount ?? !config.fallbackData
  };
  const swr = useSWRNext(key, fetcher, fallbackConfig);
  const {
    mutate
  } = swr;
  (0, _react.useEffect)(() => {
    if (config.fallbackData && !hasMounted.current) {
      // Populate the cache with the initial data
      mutate(config.fallbackData, false);
    }
  }, [mutate, config.fallbackData, key]);
  (0, _react.useEffect)(() => {
    hasMounted.current = true;
    return () => {
      hasMounted.current = false;
    };
  }, []);
  return swr;
};
exports.initialDataMiddleware = initialDataMiddleware;
